import { Popover } from 'bootstrap'

export const popover = {
  mounted(el) {
    // eslint-disable-next-line no-unused-vars
    const popover = new Popover(el, { container: 'body' })
  }
}
